import UserProfile from "components/UserProfile/UserProfile"

import { useEffect, useState } from "react"

import API from "components/Apis/API"
import $ from "jquery"
import { useForm } from "react-hook-form"
import toast, { Toaster } from "react-hot-toast"

// react-bootstrap components
import { busesAPI } from "components/Apis/Buses"
import { deletePartials } from "components/Apis/partials"
import TrailerPackingPlan from "components/Buses/trailerPackingPlan/TrailerPackingPlan"
import { EmptyCellFiller } from "components/KPIs/tabs/individuals/individuals"
import TableStyle from "components/Options/TableStyle"
import { isOrderABusByNamingConvention } from "components/Orders/helpers"
import BlankSpace from "components/UI/Atoms/BlankCell"
import LoadingAnimation from "components/UI/Loader"
import { HistoryModal } from "components/Updates/historyModal"
import PartialCreator from "components/Warehouse/modals/PartialCreation"
import { BOLPrinter } from "components/Warehouse/modals/PrintBOL"
import { OrderNotes } from "components/Warehouse/rows/order"
import {
  Button,
  Col,
  Modal,
  ProgressBar,
  Row,
  Spinner,
  Table
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { fetchActiveBusesForLane } from "redux/logistics/activeBusesSlice"
import { fetchDirectPickupOrders } from "redux/logistics/orders/ordersSlice"
import { fetchLaneStatuses } from "redux/warehouse/lanesSlice"
import { setShowReduxModal } from "redux/warehouse/warehouseSlice"
import { openModal } from "redux/navigation/modalStates"


const formatDate = (date) => {
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    // year: 'numeric',
    // month: 'long',
    // day: 'numeric'
  });
};

const formatDBDate = (date) => {
  return date.toISOString().split('T')[0];
}

const Buses = () => {
  const buses = useSelector((state) => state.activeBuses.data.buses)
  const partialableOrders = useSelector((state) => state.activeBuses.data.partialable_orders)
  const todaysPickupOrders = useSelector((state) => state.orders.todaysPickupOrders)
  const loading = useSelector((state) => state.activeBuses.loading)
  const showPartialCreationModal = useSelector((state) => state.warehouse.modalStates.partialCreator.showModal)
  const { lanesStatusesLoading, lanesStatusesError, data: lanesStatuses } = useSelector((state) => state.lanes.laneStatuses)
  
  const [bus, setBus] = useState([])
  const [showStarboardPush, setShowStarboardPush] = useState(false)

  const [directOrdersDate, setDirectOrdersDate] = useState(formatDBDate(new Date(Date.now())))
  const dispatch = useDispatch()

  const {
    formState: { errors },
    handleSubmit,
  } = useForm()


  const handleShowPushStarboard = () => setShowStarboardPush(true)
  const handleClosePushStarboard = () => setShowStarboardPush(false)



  const [busSizeOptions, setBusSizeOptions] = useState([])
  useEffect(() => {
    if (busSizeOptions.length === 0) {
      busesAPI.getSizeOptions()
        .then(data => {
          if (data) {
            setBusSizeOptions(data);
          }
        })
        .catch(error => {
          console.error("Failed to fetch size options:", error);
        });
    }
  }, []);


  const showStarboardPushModal = async (bus) => {
    setBus(bus)
    handleShowPushStarboard()
  }
  
  const starboardPush = async () => {
    const toastId = toast.loading("Pushing data ...")

    const url = "" + "admin/push_to_starboard"
    const token = await UserProfile.getToken()
    const formData = new FormData($(".starboardForm")[0])
    formData.append("bus_id", bus.bus_id)

    const response = await API.postData(url, formData)
    const data = response
    if (data.status == true) {
      toast.success(data.msg)
      handleClosePushStarboard()
    } else {
      toast.error(data.msg)
    }
    toast.dismiss(toastId)
  }


  const [tab, setTab] = useState({ name: "LRD NBB", id: 1 })
  const tabs = [
    { name: "LRD NBB", id: 1, laneID: 7 },
    { name: "CKV SBB", id: 2, laneID: 8 },
    { name: "CKV NBB", id: 3, laneID: 9 },
    { name: "DTW", id: 4, laneID: 5 },
    { name: "DTW SB", id: 5, laneID: 6 },
  ]

  useEffect(() => {
    dispatch(fetchActiveBusesForLane(tab.id))
    dispatch(fetchLaneStatuses())
  }, [tab])

  useEffect(() => {
    dispatch(
      fetchDirectPickupOrders(
        {
          lane__number: tab.id,
          pickup_date__date: directOrdersDate,
        },
      )
    )
  }, [tab, directOrdersDate])

  return (
    <>
      <Toaster position='bottom-right' />
      <div
        style={{
          opacity: (loading && !showPartialCreationModal) ? 1 : 0,
          transition: "opacity 0.5s ease-out",
          position: "fixed",
          justifyContent: "center",
          zIndex: loading ? 1000 : -1,
          top: "40%",
          left: "50%",
        }}
      >
        <div className="d-flex justify-content-center align-items-center">
          <LoadingAnimation />
        </div>
      </div>
      <div className="row warehouse-main-section-buttons-wrapper">
        <div className="col">
          {tabs.map((ttab) => {
            const status = lanesStatuses?.find(status => status.id == ttab.laneID);
            const faultsCount = status?.bus_faults_count || 0;
            const showDanger = faultsCount > 0;

            return (
              <button
                key={ttab.name}
                onClick={() => setTab(ttab)}
                className={`warehouse-main-header ${tab.name === ttab.name ? "warehouse-active" : ""}`}
              >
                {ttab.name}
                <span
                  className={`badge counter-badge ${showDanger ? "bg-danger" : "bg-success"}`}
                >
                  {
                    lanesStatusesLoading || !lanesStatuses
                      ? <Spinner animation="border" size="sm" />
                      : faultsCount === 0
                        ? <i className="fa fa-smile"></i>
                        : <>{faultsCount}</>
                  }
                </span>
              </button>
            );
          })}

        </div>
      </div>
      <div
        style={{
          backfaceVisibility: loading ? "hidden" : "visible",
          opacity: loading ? 0.8 : 1,
          transition: "opacity 0.6s ease-in-out",
          pointerEvents: loading ? "none" : "auto",
        }}
      >
        <Row>
          {/* Buses view */}
          <Col md='12'>
            <div className="table-header">
              <h1>
                Active Outbound Buses
              </h1>
            </div>
            <Table className='warehouse-dashboard-table active-buses-table table-striped'>
              <thead>
                <tr>
                  <th>Bus</th>
                  <th>Utilization</th>
                  <th>Schedule</th>
                  <th>Stops</th>
                  <th style={{ width: "28%" }}>Notes</th>
                  <th>Partial Assignments</th>
                  <th>Act.</th>
                </tr>
              </thead>
              <tbody>
                {
                  buses.length === 0 && (
                    <tr>
                      <td colSpan={7} className='text-center'>
                        No Buses
                      </td>
                    </tr>
                  )
                }
                {buses.map((row, i) => {
                  const orders = row.orders || []
                  const packingPlan = row.packing_plan || {}
                  const dockedOrders = orders.filter(
                    order => order.dock?.toLowerCase() === "yes"
                  )
                  const totalOrders = orders.length
                  const dockedPercent = totalOrders ? Math.round(100 * dockedOrders.length / totalOrders) : 0
                  const tetrisLengthUsed = packingPlan.p_length_used || 0
                  const tetrisLengthValue = packingPlan.length_used || 0

                  const tetrisLengthVariant = tetrisLengthUsed > 90 ? "danger" :
                    tetrisLengthUsed > 70 ? "warning" :
                      "success"
                  const weightVariant = row.p_weight > 90 ? "danger" :
                    row.p_weight > 70 ? "warning" :
                      "success"
                  const dockVariant = dockedPercent === 100 && totalOrders
                    ? "success"
                    : "warning"

                  return (
                    <tr key={`bus-tab-row-${row.id}`} className={`bus-row-${isOrderABusByNamingConvention(row)}`}>
                      <td>
                        <div className="bus-cell">
                          <div className="bus-name">{row.bus}</div>
                          <span>
                            <i className="fa fa-truck" /> {row.trailer_size || <BlankSpace />}
                          </span>
                          <span>
                            <i className="fa fa-user" /> {row.driver || <BlankSpace />}
                          </span>
                        </div>
                      </td>
                      <td className="utilization-cell">
                        {tetrisLengthValue ? (
                          <div className="stat-block">
                            <div className="stat-label">
                              <span>Length</span>
                              <span className="stat-value">{packingPlan.length_used ?? 0} ({packingPlan.p_length_used ?? 0}%)</span>
                            </div>
                            <ProgressBar
                              now={tetrisLengthUsed}
                              variant={tetrisLengthVariant}
                              className="compact-progress"
                            />
                          </div>
                        ) : null}
                        <div className="stat-block">
                          <div className="stat-label">
                            <span>Weight</span>
                            <span className="stat-value">{row.weight} ({row.p_weight}%)</span>
                          </div>
                          <ProgressBar
                            now={row.p_weight}
                            variant={weightVariant}
                            className="compact-progress"
                          />
                        </div>
                        <div className="stat-block">
                          <div className="stat-label">
                            <span>Area</span>
                            <span className="stat-value">{packingPlan.area_used ?? 0} ({packingPlan.p_area_used ?? 0}%)</span>
                          </div>
                          <ProgressBar
                            now={packingPlan.p_area_used || 0}
                            variant={
                              packingPlan.p_area_used > 90 ? "danger" :
                                packingPlan.p_area_used > 70 ? "warning" :
                                  "success"
                            }
                            className="compact-progress"
                          />
                        </div>
                        <div className="stat-block">
                          <div className="stat-label">
                            <span>Volume</span>
                            <span className="stat-value">{packingPlan.volume_used ?? 0} ({packingPlan.p_volume_used ?? 0}%)</span>
                          </div>
                          <ProgressBar
                            now={packingPlan.p_volume_used || 0}
                            variant={
                              packingPlan.p_volume_used > 90 ? "danger" :
                                packingPlan.p_volume_used > 70 ? "warning" :
                                  "success"
                            }
                            className="compact-progress"
                          />
                        </div>
                      </td>
                      <td>
                        <div className="schedule">
                          <div className="schedule-pill subtle">
                            <span className="label">Freight on Dock</span>
                            <span className="value">
                              {dockedOrders.length}/{totalOrders || 0} ({dockedPercent}%)
                            </span>
                          </div>
                          <div>
                            
                          </div>
                          <div className="schedule-pill subtle">
                            <span className="label">Pickup</span>
                            <span className="value">
                              {row.scheduled_pickup ? row.scheduled_pickup : <BlankSpace />}
                            </span>
                          </div>
                          <div className="schedule-pill">
                            <span className="label">Drop Dead</span>
                            <span className="value">
                              {row.drop_dead ? row.drop_dead : <BlankSpace />}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="schedule-stops">
                          <div className="bus-stops">
                            {
                              (row.destinations && row.destinations.length > 0)
                                ? row.destinations.map(terminal => (
                                  <span key={terminal.id || terminal.short_form_name} className="stop-pill">
                                    {terminal.short_form_name}
                                  </span>
                                ))
                                : <BlankSpace />
                            }
                          </div>
                        </div>
                      </td>
                      <td className='notes-cell'>
                        <label className="cell-label d-block">Notes</label>
                        <div className="d-flex flex-column">
                          <textarea
                            name='pieces_left'
                            type='text'
                            className={`bus-inline-input bus-notes piece_${row.bus_id}`}
                            defaultValue={row.pieces_left}
                            onBlur={(e) => {
                              busesAPI.patch(row.bus_id, { pieces_left: e.target.value })
                                .then(() => {
                                  toast.success("Bus updated successfully!")
                                })
                                .catch((error) => {
                                  toast.error(`Failed to update bus: ${error.message}`);
                                })
                            }}
                          />
                          <HistoryModal
                            bus={row}
                          />
                        </div>
                      </td>
                      <td>
                        {
                          (row.partials.length > 0)
                            ? (
                              row.partials.map((partial, i) => (
                                <div key={partial.id || i} className="col p-0 m-0">
                                  {
                                    partial.quantity
                                      ? <span className="badge badge-success">[{partial.quantity}] from {partial.order.order_no}</span>
                                      :
                                      <span
                                        className="badge badge-warning"
                                        onClick={() => {
                                          deletePartials({ id: partial.id })
                                          dispatch(
                                            fetchActiveBusesForLane(tab.id)
                                          )
                                        }}
                                        style={{ cursor: 'pointer' }}
                                      >
                                        {partial.order.order_no} -
                                      </span>
                                  }
                                </div>
                              ))
                            )
                            : <BlankSpace />
                        }
                      </td>
                      <td className='action-buttons compact'>
                        <div className='d-flex actions-vertical'>
                          <button
                            className='button square d-flex'
                            onClick={() => {
                              dispatch(
                                openModal({ type: 'BUS_DETAILS', props: { busId: row.id } })
                              )
                            }}
                          >
                            <i className='fa fa-eye' />
                          </button>
                          <button
                            className="button square d-flex"
                            onClick={() => showStarboardPushModal(row)}
                          >
                            <i
                              className='fa fa-upload'
                              style={{ color: row.sb_status == 1 ? 'green' : '' }}
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col md='12'>
            <div className="table-header">
              <h1>
                Partialable Orders
              </h1>
            </div>
            <Table className='warehouse-dashboard-table'>
              <thead>
                <tr>
                  <th>Pro</th>
                  <th>Outbound</th>
                  <th>Dock</th>
                  <th>Delivery Location</th>
                  <th>Delivery Date</th>
                  <th>Units</th>
                  <th>Weight</th>
                  <th>Length</th>
                  <th>Bus Assignments</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {
                  partialableOrders.length === 0 && (
                    <tr>
                      <td colSpan={10} className='text-center'>
                        No Partialable Orders
                      </td>
                    </tr>
                  )
                }
                {partialableOrders.map((order, i) => (
                  <tr key={'order-' + order.id}>
                    <td>{order.order_no} {order.order_group} {order.backorder?.order_no}</td>
                    <td>{order.bus ? <>{order.bus}</> : <BlankSpace />}</td>
                    <td>
                      {order.dock
                        ?
                        <>
                          {order.dock.toLowerCase() === "yes"
                            ? <span className="badge badge-success">Yes</span>
                            : <span>{order.dock}</span>
                          }
                        </>
                        : (<BlankSpace />)
                      }
                    </td>
                    <td>{order.delivery_city_state}</td>
                    <td>{order.delivery_date}</td>
                    <td>
                      {
                        order.was_order_line_partialized
                          ? <>{order.units_at_terminal} / {order.units}</>
                          : <>{order.units}</>
                      }
                    </td>
                    <td>{order.weight}</td>
                    <td>{order.total_length}</td>
                    <td>
                      {order.partials.map((partial, i) => (
                        <div className="col p-0 m-0">
                          {
                            partial.quantity
                              ? <span className="badge badge-success">[{partial.quantity}] on {partial.bus.name} | {partial.bus.driver}</span>
                              :
                              <span
                                className="badge badge-warning"
                                onClick={() => {
                                  deletePartials({ id: partial.id })
                                  dispatch(
                                    fetchActiveBusesForLane(tab.id)
                                  )
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                {partial.bus?.name} -
                              </span>
                          }
                        </div>
                      ))}
                      <div className="col p-0 m-0">
                        <span
                          style={{ cursor: 'pointer' }}
                          className='badge badge-dark'
                          onClick={() => {
                            dispatch(
                              setShowReduxModal({
                                partialCreator: {
                                  orderId: order.id,
                                  showModal: true,
                                },
                              })
                            );
                          }}
                        >
                          Add Partial +
                        </span>
                      </div>
                    </td>
                    <td style={{ width: '40%', maxHeight: '40px', padding: '6px' }}>
                      <div className="d-flex justify-content-between">
                        <div className="flex-column">
                        </div>
                        <div style={{ width: '100%' }} className="flex-column">
                          <OrderNotes order={order} />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col md='12'>
            <div className="table-header">
              <h1>
                Direct Outbound
                <select
                  defaultValue={directOrdersDate}
                  onChange={(e) => setDirectOrdersDate(e.target.value)}
                  className="table-title-select"
                >
                  <option value={formatDBDate(new Date(Date.now()))}>Today</option>
                  <option value={formatDBDate(new Date(Date.now() + 86400000 * 1))}>Tomorrow</option>
                  <option value={formatDBDate(new Date(Date.now() + 86400000 * 2))}>
                    {formatDate(new Date(Date.now() + 86400000 * 2))}
                  </option>
                  <option value={formatDBDate(new Date(Date.now() + 86400000 * 3))}>
                    {formatDate(new Date(Date.now() + 86400000 * 3))}
                  </option>
                  <option value={formatDBDate(new Date(Date.now() + 86400000 * 4))}>
                    {formatDate(new Date(Date.now() + 86400000 * 4))}
                  </option>
                  <option value={formatDBDate(new Date(Date.now() + 86400000 * 5))}>
                    {formatDate(new Date(Date.now() + 86400000 * 5))}
                  </option>
                  <option value={formatDBDate(new Date(Date.now() + 86400000 * 6))}>
                    {formatDate(new Date(Date.now() + 86400000 * 6))}
                  </option>
                </select>
              </h1>
            </div>
            <Table className='warehouse-dashboard-table'>
              <thead>
                <tr>
                  <th>Pro</th>
                  <th>Outbound</th>
                  <th>Dock</th>
                  <th>Delivery Location</th>
                  <th>Delivery Date</th>
                  <th>Units</th>
                  <th>Weight</th>
                  <th>Length</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {
                  (todaysPickupOrders && todaysPickupOrders.length != 0)
                    ? todaysPickupOrders.map((order, i) => (
                      <tr key={'order-' + order.id}>
                        <td>{order.order_no} {order.order_group}</td>
                        <td>{order.bus ? <>{order.bus}</> : <BlankSpace />}</td>
                        <td>
                          {order.dock
                            ?
                            <>
                              {order.dock === "Yes"
                                ? <span className="badge badge-success">Yes</span>
                                : <span>{order.dock}</span>
                              }
                            </>
                            : (<BlankSpace />)
                          }
                        </td>
                        <td>{order.delivery_city_state}</td>
                        <td>{order.delivery_date}</td>
                        <td>
                          {
                            order.was_order_line_partialized
                              ? <>{order.units_at_terminal} / {order.units}</>
                              : <>{order.units}</>
                          }
                        </td>
                        <td>{order.weight}</td>
                        <td>{order.total_length}</td>
                        <td style={{ width: '40%', maxHeight: '40px', padding: '6px' }}>
                          <div className="d-flex justify-content-between">
                            <div className="flex-column">
                            </div>
                            <div style={{ width: '100%' }} className="flex-column">
                              <OrderNotes order={order} />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                    : (
                      <tr>
                        <td colSpan={9} className='text-center'>
                          {
                            (todaysPickupOrders && todaysPickupOrders.length === 0)
                              ? "No Direct Outbound Orders"
                              : "Loading..."
                          }
                        </td>
                      </tr>
                    )
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Modal
        show={showStarboardPush}
        onHide={handleClosePushStarboard}
        className=' bd-example-modal-lg'
      >
        <form onSubmit={handleSubmit(starboardPush)} className='starboardForm'>
          <Modal.Header>
            <Modal.Title style={{ width: "100%", margin: "0 0 0" }}>
              Push Bus to Starboard
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ paddingTop: "10px" }}>
            <Table
              className='table-hover table-striped'
              style={{ width: "100%", margin: "0 0 0" }}
            >
              <tbody>
                <tr>
                  <th>Pickup Date</th>
                  <td>
                    <input
                      name='pickup_date'
                      type='datetime-local'
                      className='form-control mt-1 modalInput'
                      placeholder='Pick up date'
                      defaultValue={bus.sb_pickup_date}
                      required
                    />
                  </td>
                  <th>Delivery Date</th>
                  <td>
                    <input
                      name='delivery_date'
                      type='datetime-local'
                      className='form-control mt-1 modalInput'
                      placeholder='Delivery date'
                      defaultValue={bus.sb_delivery_date}
                      required
                    />
                  </td>
                </tr>

                <tr>
                  <th>Pickup Location</th>
                  <td>
                    <input
                      name='pickup_at'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter pickup address. eg, 20054 Street'
                      defaultValue={bus.sb_pickup_location}
                      required
                    />

                    <input
                      name='pickup_state'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='State, eg. MI'
                      defaultValue={bus.sb_pickup_state}
                      required
                      style={{ float: "left", width: "50%" }}
                      maxLength={2}
                    />

                    <input
                      name='pickup_zip'
                      type='number'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter pickup zip. eg. 1004'
                      defaultValue={bus.sb_pickup_zip}
                      required
                      style={{ width: "50%" }}
                    />

                    <input
                      name='pickup_city'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter pickup city name. eg. Chicago'
                      defaultValue={bus.sb_pickup_city}
                      required
                    />
                  </td>
                  <th>Delivery Location</th>
                  <td>
                    <input
                      name='delivery_at'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter delivery address. eg, 20054 Street'
                      defaultValue={bus.sb_delivery_location}
                      required
                    />

                    <input
                      name='delivery_state'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='State, eg. MI'
                      defaultValue={bus.sb_delivery_state}
                      required
                      style={{ float: "left", width: "50%" }}
                      maxLength={2}
                    />

                    <input
                      name='delivery_zip'
                      type='number'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter delivery zip. eg. 1004'
                      defaultValue={bus.sb_delivery_zip}
                      required
                      style={{ width: "50%" }}
                    />

                    <input
                      name='delivery_city'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter delivery city name. eg. Chicago'
                      defaultValue={bus.sb_delivery_city}
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <th>Pickup Business Name</th>
                  <td>
                    <input
                      name='pickup_bname'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter delivery business name'
                      required
                      defaultValue={bus.sb_pickup_bname}
                    />
                  </td>
                  <th>Delivery Business Name</th>
                  <td>
                    <input
                      name='delivery_bname'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter pickup business name'
                      required
                      defaultValue={bus.sb_delivery_bname}
                    />
                  </td>
                </tr>

                <tr>
                  <th>Pro No</th>
                  <td>
                    <input
                      name='pro_no'
                      type='text'
                      className='form-control mt-1 modalInput'
                      placeholder='Enter pro number'
                      required
                      defaultValue={bus.sb_pro_number}
                    />
                  </td>

                  <th>Vehicle Size</th>
                  <td>
                    <select
                      className='form-control'
                      name='vehicle_size'
                      defaultValue={bus.sb_vehicle_size}
                    >
                      <option value='TRACTOR'>TRACTOR</option>
                      <option value='SPRINTER'>SPRINTER</option>
                      <option value='TL'>TL</option>
                      <option value='CUBE VAN'>CUBE VAN</option>
                      <option value='DOCK HIGH STRAIGHT'>
                        DOCK HIGH STRAIGHT
                      </option>
                      <option value='CARGO VAN'>CARGO VAN</option>
                      <option value='FLATBED'>FLATBED</option>
                      <option value='LTL'>LTL</option>
                      <option value='REEFER'>REEFER</option>
                      <option value='CAR'>CAR</option>
                      <option value='AIR EXPRESS CARGO'>
                        AIR EXPRESS CARGO
                      </option>
                      <option value='AIR CHARTER'>AIR CHARTER</option>
                      <option value='AIRCRAFT'>AIRCRAFT</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleClosePushStarboard}>
              Close
            </Button>
            <Button variant='primary' type='submit'>
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
      <PartialCreator />
    </>
  )
}

export default Buses
